import React, { useState, useEffect, Fragment } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import HistoryTable from "../../clinical-services/service-steps/clinical-assessment/medical-history/historyTable";
import MedicalHistoryCreate from "../../clinical-services/service-steps/clinical-assessment/MedicalHistoryCreate";
import {
  getHistoryTypeName,
  MedicalHistoryTypes,
} from "../../clinical-services/service-steps/clinical-assessment/data";
import {
  fetchMedicalHistory,
  updateMedicalHistory,
} from "../../../../redux/modules/clinical-services/actions";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Button from "../../../common/Button";
import ConfirmationModalNew from "../../../common/ConfirmationModalNew";
import { capitalizeFirstLetter } from "../../../../helpers/functions";
import NewToolTip from "../../../common/New-ToolTip";
import {
  DeleteOptions,
  StatusOptions,
} from "../../clinical-services/service-steps/clinical-assessment/medical-history/options";

const PatientStudies = ({}) => {
  const dispatch = useDispatch();
  //#region Data
  const { medicalHistory } = useSelector((state) => state.clinicalService);
  const { id: patientId } = useParams();

  const [medicalStudyRecords, setMedicalStudyRecords] = useState([]);
  //#endregion

  //#region Pop-up
  const [showCreateSlider, setShowCreateSlider] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [selectedHistoryType, setSelectedHistoryType] = useState(
    MedicalHistoryTypes.Study
  );
  const [create, setCreate] = useState(true);
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToRestore, setIdToRestore] = useState(null);
  const [openDeleteHistory, setOpenDeleteHistory] = useState(false);
  const [openRestoreHistory, setOpenRestoreHistory] = useState(false);
  //#endregion

  //state management
  useEffect(() => {
    dispatch(fetchMedicalHistory(patientId));
  }, []);

  const MedicalStudyTab = {
    NoMedicalStudy: 0,
    MedicalStudyInformation: 1,
  };
  const [selectedTab, setSelectedTab] = useState(null);
  const [statusFilter, setstatusFilter] = useState("active");

  //#region helper functions
  const setTypeFilter = (filter) => {
    if (create) {
      setstatusFilter(filter);
    }
  };

  const hasActiveStudies = () =>
    medicalStudyRecords.some((item) => item.status === "active");

  const isAnyHistory = () => {
    return medicalStudyRecords.length > 0;
  };

  const manageClick = () => {
    document.body.classList.toggle("overflow-hidden");
  };
  //#endregion

  //#region Data update functions
  const deleteHistory = (type, recordId) => {
    var records = medicalStudyRecords;

    const deleteObject = records.find((item) => item.id === recordId);
    deleteObject.status = "inactive";

    let obj = {
      noKnownMedicalHistory:
        medicalHistory.medicalConditions.every(
          (val) => val.status === "inactive"
        ) &&
        records.every((val) => val.status === "inactive") &&
        medicalHistory.surgeries.every((val) => val.status === "inactive"),
      medicalConditions: medicalHistory.medicalConditions,
      medicalStudies:
        type === MedicalHistoryTypes.Study
          ? records
          : medicalHistory.medicalStudies,
      surgeries: medicalHistory.surgeries,
    };
    dispatch(updateMedicalHistory(patientId, obj, 'deleted'));
  };

  const restoreHistory = (type, recordId) => {
    var records = medicalStudyRecords;

    const restoreObject = records.find((item) => item.id === recordId);
    restoreObject.status = "active";
    restoreObject.confirmedDate = null;

    let obj = {
      noKnownMedicalHistory:
        medicalHistory.medicalConditions.every(
          (val) => val.status === "inactive"
        ) &&
        records.every((val) => val.status === "inactive") &&
        medicalHistory.surgeries.every((val) => val.status === "inactive"),
      medicalConditions: medicalHistory.medicalConditions,
      medicalStudies:
        type === MedicalHistoryTypes.Study
          ? records
          : medicalHistory.medicalStudies,
      surgeries: medicalHistory.surgeries,
    };
    dispatch(updateMedicalHistory(patientId, obj, 'restored'));
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    if (medicalHistory) {
      setMedicalStudyRecords(medicalHistory.medicalStudies);

      if (
        medicalHistory.medicalStudies?.filter(
          (val) => val.status === "active"
        ).length > 0
      ) {
        setSelectedTab(MedicalStudyTab.MedicalStudyInformation);
      } else {
        setSelectedTab(MedicalStudyTab.NoMedicalStudy);
      }
    }
  }, [medicalHistory]);
  //#endregion

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <div className="flex flex-1 h-[600px]">
            <div className="w-full gap-5 h-full">
              <div className="flex items-center justify-between mt-2.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Medical History - Medical Studies
                </h4>
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>

              {/* option boxes for no medical histoy and medical history information */}
              <div
                id="medicalHistoryContainer"
                className="flex flex-col h-[590px] gap-6 overflow-scroll overflow-y-auto overflow-x-hidden bg-scroll"
              >
                {/* No medical study */}
                <div
                  className={`flex justify-between p-6 border rounded 
                                        ${
                                          selectedTab ===
                                          MedicalStudyTab.NoMedicalStudy
                                            ? "border-gray-100 border-2 bg-gray-20"
                                            : "border-gray-100"
                                        }`}
                >
                  <div className="flex">
                    <div className="flex-col justify-center items-center pr-6">
                      <h3>
                        <input
                          id="in-person"
                          name="visit-type"
                          onClick={() => {
                            if (!hasActiveStudies()) {
                              setSelectedTab(MedicalStudyTab.NoMedicalStudy);
                            }
                          }}
                          value={selectedTab === MedicalStudyTab.NoMedicalStudy}
                          checked={
                            selectedTab === MedicalStudyTab.NoMedicalStudy
                          }
                          type="radio"
                          disabled={hasActiveStudies()}
                          className={`w-[45px] h-[45px] border-gray-100 form-radio text-REELTeal focus:ring-transparent ${
                            hasActiveStudies()
                              ? "cursor-not-allowed opacity-60"
                              : "cursor-pointer"
                          }`}
                          data-tooltip-id={
                            hasActiveStudies()
                              ? "no-studies-disabled-tooltip"
                              : undefined
                          }
                        />
                      </h3>
                    </div>
                    <div className="flex flex-col justify-center">
                      <h3
                        className={`text-xl font-semibold ${
                          hasActiveStudies() ? "text-gray-500" : "text-gray-900"
                        }`}
                      >
                        No Medical Studies
                      </h3>
                    </div>
                  </div>
                  {hasActiveStudies() && (
                    <NewToolTip
                      id="no-studies-disabled-tooltip"
                      place="bottom-start"
                      render={() => (
                        <div className="bg-gray-20 p-2 max-w-md flex flex-col">
                          <p className="text-teal-300 text-left text-body-sm font-normal">
                            Delete all medical studies to enable 'No Medical Studies'.
                          </p>
                        </div>
                      )}
                    />
                  )}
                </div>
                {/* Medical study information */}
                <div
                  className={`flex flex-col gap-6 p-6 border rounded ${
                    selectedTab === MedicalStudyTab.MedicalStudyInformation
                      ? "border-gray-100 border-2 bg-gray-20"
                      : "border-gray-100"
                  }`}
                >
                  {/* Start: Header */}
                  <div className="flex justify-between">
                    <div className="flex">
                      <div className="flex justify-center items-center pr-6">
                        <h3>
                          <input
                            id="in-person"
                            name="visit-type"
                            onClick={() => {
                              setSelectedTab(
                                MedicalStudyTab.MedicalStudyInformation
                              );

                              if (!isAnyHistory()) {
                                setShowCreateSlider(true);
                              } else {
                                setShowCreateSlider(false);
                              }
                            }}
                            value={
                              selectedTab ===
                              MedicalStudyTab.MedicalStudyInformation
                            }
                            checked={
                              selectedTab ===
                              MedicalStudyTab.MedicalStudyInformation
                            }
                            type="radio"
                            className="w-[45px] h-[45px] border-gray-100 cursor-pointer form-radio text-REELTeal focus:ring-transparent"
                          />
                        </h3>
                      </div>
                      <div className="flex flex-col">
                        <h3 className="text-xl font-semibold text-gray-900">
                          {isAnyHistory()
                            ? "Medical Study Information"
                            : "Add Medical Study"}
                        </h3>
                        <p className="text-base text-gray-800">
                          {isAnyHistory() && (
                            <span className="text-sm text-teal-300">
                              (Delete all medical studies to enable ‘No
                              Medical Studies.)
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                    {selectedTab ===
                      MedicalStudyTab.MedicalStudyInformation && (
                      <div className="flex flex-row pr-3.5">
                        <Menu
                          as="div"
                          className="relative inline-block text-left pt-[6px]"
                        >
                          <div className="flex items-center">
                            <Menu.Button className="flex flex-row font-semibold mr-6 bg-white py-[14px] rounded-[4px] px-[16px] text-base min-w-[220px] h-full border-[0px] focus:outline-[0px] focus:ring-[0px] text-gray-900 p-0 focus:outline-none disabled:cursor-not-allowed text-left text-body-md items-center justify-between">
                              <span className="flex">
                                {
                                  StatusOptions.find(
                                    (x) => x.value === statusFilter
                                  ).label
                                }
                              </span>
                              <div className="flex flex-col">
                                <span>
                                  <ChevronDownIcon
                                    className={`w-5 transform transition-all `}
                                  />
                                </span>
                              </div>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform translate-y-2 opacity-0 scale-95"
                            enterTo="transform translate-y-0 opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform translate-y-0 opacity-100 scale-100"
                            leaveTo="transform translate-y-2 opacity-0 scale-95"
                          >
                            <Menu.Items className="min-w-[220px] absolute z-10 left-0 w-40 origin-top-left bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
                              {StatusOptions.map((status) => (
                                <Menu.Item
                                  className={`block w-full text-left px-3 py-3 border-b border-b-gray-20 
                                                                                ${
                                                                                  statusFilter ===
                                                                                    status.value &&
                                                                                  "bg-blue-100"
                                                                                } hover:bg-gray-50`}
                                  onClick={(e) => {
                                    setstatusFilter(status.value);
                                  }}
                                >
                                  <span>{status.label}</span>
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                        <Button
                          className="flex rounded-[4px] text-base !w-[220px]"
                          type="primary"
                          text="Add Medical Study"
                          onClick={() => {
                            setShowCreateSlider(true);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {/* End: Header */}
                  {/* Start: Medical condition table */}
                  {selectedTab === MedicalStudyTab.MedicalStudyInformation &&
                    medicalStudyRecords?.filter((val) =>
                      statusFilter === "all"
                        ? true
                        : val.status === statusFilter
                    ).length > 0 && (
                      <HistoryTable
                        showConfirmation={false}
                        headerName="Medical Studies"
                        isMedicalConditionTable={false}
                        records={medicalStudyRecords.filter((val) =>
                          statusFilter === "all"
                            ? true
                            : val.status === statusFilter
                        )}
                        onEdit={(study) => {
                          setSelectedHistory(study);
                          setCreate(false);
                          setShowCreateSlider(true);
                        }}
                        onDelete={(study) => {
                          setSelectedHistory(study);
                          setOpenDeleteHistory(true);
                          setIdToDelete(study.id);
                        }}
                        onRestore={(study) => {
                          setSelectedHistory(study);
                          setOpenRestoreHistory(true);
                          setIdToRestore(study.id);
                        }}
                      />
                    )}
                  {/* End: Medical condition table */}

                  {/* Start: Edit/Delete/Restore pop-ups */}
                  <ConfirmationModalNew
                    type="primary"
                    title={`Delete ${getHistoryTypeName(selectedHistoryType)}`}
                    content={() =>
                      `Are you sure you want to delete ${capitalizeFirstLetter(
                        selectedHistory?.name ?? ""
                      )}?`
                    }
                    confirmAction={() => {
                      deleteHistory(selectedHistoryType, idToDelete);
                      setSelectedHistory(null);
                      setOpenDeleteHistory(false);
                      setIdToDelete(null);
                    }}
                    optionLabel="Reason"
                    open={openDeleteHistory}
                    handleClose={() => {
                      setSelectedHistory(null);
                      setOpenDeleteHistory(false);
                      setIdToDelete(null);
                    }}
                    onCross={() => {
                      setSelectedHistory(null);
                      setOpenDeleteHistory(false);
                      setIdToDelete(null);
                    }}
                    options={DeleteOptions}
                  />
                  <ConfirmationModalNew
                    open={openRestoreHistory}
                    title={`Restore ${getHistoryTypeName(selectedHistoryType)}`}
                    type="primary"
                    confirmText="Yes"
                    content={() => (
                      <p className="p-7">
                        Are you sure you wish to restore this{" "}
                        {getHistoryTypeName(selectedHistoryType)}?
                      </p>
                    )}
                    onCross={() => {
                      setSelectedHistory(null);
                      setOpenRestoreHistory(false);
                      setIdToRestore(null);
                    }}
                    handleClose={() => {
                      setSelectedHistory(null);
                      setOpenRestoreHistory(false);
                      setIdToRestore(null);
                    }}
                    confirmAction={() => {
                      restoreHistory(selectedHistoryType, idToRestore);
                      setSelectedHistory(null);
                      setOpenRestoreHistory(false);
                      setIdToRestore(null);
                    }}
                  />
                  {/* End: Edit/Delete/Restore pop-ups */}

                  <MedicalHistoryCreate
                    open={showCreateSlider}
                    onClose={() => {
                      setShowCreateSlider(false);
                      manageClick();
                      setSelectedHistory(null);
                      setCreate(true);
                    }}
                    selectedHistoryType={selectedHistoryType}
                    onSave={() => {
                      setTypeFilter("all");
                    }}
                    selectedHistory={selectedHistory}
                    patientId={patientId}
                    create={create}
                    // patientMedicalConditions={medicalStudyRecords}
                    patientMedicalStudies={medicalStudyRecords}
                    // patientMedicalSurgeries={medicalSurgeriesRecords}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientStudies;
